import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { store } from '@/state/store';
import { assert_false } from '@shared/asserts/utils_asserts';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FN_IMAGE__get_available_tabs } from './FN_IMAGE__get_available_tabs';

const ENUM = ENUM__page_generation_layout_images_edit_tab;

export function FN_IMAGE__get_best_first_tab_for_image_edit(field: FIELD__image_asset) {
  assert_false(field.meta.data__is_linked);

  let available_tabs = FN_IMAGE__get_available_tabs(field);

  /*
   *
   */
  if (available_tabs.is_empty()) return ENUM.VIEW;
  if (available_tabs.length == 1) return available_tabs[0];

  /*
   *
   */

  let { g_image_edit__tab } = store.getState().slice_ui;
  if (available_tabs.includes(g_image_edit__tab) && g_image_edit__tab != ENUM.VIEW) return g_image_edit__tab;

  /*
   *
   */
  if (available_tabs.includes(ENUM.MASK)) return ENUM.MASK;
  if (available_tabs.includes(ENUM.LINE__DRAW)) return ENUM.LINE__DRAW;
  if (available_tabs.includes(ENUM.CROP)) return ENUM.CROP;

  /*
   *
   */
  if (available_tabs.includes(ENUM.VIEW)) return ENUM.VIEW;

  return available_tabs[0];
}
